import React from 'react';
import classNames from 'classnames';

function getHeight(windowWidth) {
  if (windowWidth < 340) return 42;
  if (windowWidth < 370) return 46;

  return 50;
}

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Navbar({ className = null, children, ...otherProps }) {
  const classes = classNames('ws-navbar', className);

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
}

Navbar.getHeight = getHeight;

export default Navbar;
